import { GroupType } from '../../model/enumerations';
import template from './mx-advanced-search.component.html';
import { EventCodes } from '../../../../App/model/event-codes';

export class MxAdvancedSearchController {
	static $inject = [
		'mx.shell.EventService',
		'mx.app.DeviceService',
		'mx.shell.SidebarService',
		'mx.shell.SearchProviderService',
		'mx.SolutionBuilderAgent.SearchQueryService',
		'mx.shell.UserProfileService',
		'mx.internationalization',
		'$scope',
		'mx.SolutionBuilderAgent.SearchQueryGroup',
	];

	SearchQueryGroup;
	deviceService;
	sidebarService;
	searchService;
	searchQueryService;
	userProfileService;
	context;

	filterQueries = '';
	sortBy = 'title';
	queries = [];
	conditionProperties = [];
	uiToken;

	constructor(eventService, deviceService, sidebarService, searchService, searchQueryService, userProfileService, i18n, $scope, SearchQueryGroup) {
		this.SearchQueryGroup = SearchQueryGroup;
		this.deviceService = deviceService;
		this.sidebarService = sidebarService;
		this.searchService = searchService;
		this.searchQueryService = searchQueryService;
		this.userProfileService = userProfileService;
		this.eventService = eventService;

		this.advancedSearchGroup = new this.SearchQueryGroup();

		this.sortFields = [
			{
				field: 'title',
				name: i18n.get('solutionBuilderAgent.components.mx-advanced-search.title'),
			},
			{
				field: 'showInNavigation',
				name: i18n.get('solutionBuilderAgent.components.mx-advanced-search-query.showInNavigation'),
			},
		];

		eventService.subscribeTo(mx.SolutionBuilderAgent.Events.SearchQueryAdded, this.resetForm, $scope);

		$scope.$watch('vm.filterQueries', (text) => {
			this.queries.forEach((item) => {
				item.__visible = !text || ((item && item.title) || '').toLowerCase().indexOf(text.toLowerCase()) !== -1;
			});
		});
	}

	$onInit() {
		return this.init();
	}

	async init() {
		this.queries = (await this.searchQueryService.getQueries(this.context)) || [];
		this.userId = (await this.userProfileService.get()).id;
		this.resetForm();
	}

	isAdvancedSearchGroupValid() {
		return (this.advancedSearchGroup.conditions || this.advancedSearchGroup.groups) && this.searchQueryService.validateGroup(this.advancedSearchGroup);
	}

	searchClick() {
		if (!this.isAdvancedSearchGroupValid()) {
			return;
		}
		const currentSearch = this.searchService.currentSearch();
		currentSearch.context = this.context;
		currentSearch.searchForm.setGroup(this.advancedSearchGroup, GroupType.QueryBuilder);
		currentSearch.uiToken = this.uiToken;
		this.searchService.runSearch();
		if (this.deviceService.screenMobile()) {
			this.sidebarService.close();
		}

		this.trackTelemetry();
	}

	getFlatGroupConditions(group) {
		const childrenConditions = group.groups?.flatMap((group) => this.getFlatGroupConditions(group)) || [];
		return (group.conditions || []).concat(childrenConditions);
	}

	trackTelemetry() {
		const conditions = this.getFlatGroupConditions(this.advancedSearchGroup);

		this.eventService.dispatchEvent(EventCodes.TrackTelemetry, {
			eventName: `Advanced search executed`,
			sender: this.queryList?.parameters.id,
			senderTitle: this.queryList?.parameters.name,
			contextTypeId: this.queryList?.parameters.entities.map((entity) => entity.id),
			contextTypeTitle: this.queryList?.parameters.entities.map((entity) => entity.name),
			contextId: conditions.map((condition) => ({
				name: condition.property,
				type: condition.type,
				operator: condition.operatorTechnicalName,
			})),
		});
	}

	resetForm() {
		this.advancedSearchGroup = new this.SearchQueryGroup();
	}
}

angular.module('mx.SolutionBuilderAgent').component('mxAdvancedSearch', {
	bindings: {
		context: '=',
		uiToken: '@',
		queryList: '<',
	},
	controller: MxAdvancedSearchController,
	controllerAs: 'vm',
	template: template,
});
